/**
 * 全局配置文件
 * 统一管理API地址、超时时间等配置
 *
 * 使用说明：
 * 1. 默认使用下方配置的地址
 * 2. 支持通过环境变量覆盖（在.env文件或package.json scripts中设置）
 *    - VUE_APP_API_BASE_URL: 覆盖API基础地址
 *    - VUE_APP_API_TIMEOUT: 覆盖超时时间
 */

// 环境判断
const ENV = process.env.NODE_ENV || 'development'

/**
 * API服务配置
 * 根据不同环境配置不同的服务地址
 */
const API_CONFIG = {
  // 开发环境
  development: {
    baseURL: 'http://192.168.2.33:48080/www-services',
    timeout: 15000
  },
  // 测试环境
  test: {
    baseURL: 'http://test-api.rqan.com/www-services',
    timeout: 15000
  },
  // 生产环境
  production: {
    baseURL: 'https://www.fjrqzn.com/www-services',
    timeout: 15000
  }
}

/**
 * 获取当前环境的API配置
 */
export const getApiConfig = () => {
  const envConfig = API_CONFIG[ENV] || API_CONFIG.development

  // 支持环境变量覆盖
  return {
    baseURL: process.env.VUE_APP_API_BASE_URL || envConfig.baseURL,
    timeout: process.env.VUE_APP_API_TIMEOUT || envConfig.timeout
  }
}

/**
 * 导出常用配置
 */
export const config = {
  // 当前环境
  env: ENV,

  // API基础地址
  baseURL: getApiConfig().baseURL,

  // 请求超时时间
  timeout: getApiConfig().timeout,

  // 是否开发环境
  isDev: ENV === 'development',

  // 是否生产环境
  isProd: ENV === 'production',

  // 是否测试环境
  isTest: ENV === 'test',

  // 应用标题
  appTitle: process.env.VUE_APP_TITLE || '瑞谦智能官网'
}

// 开发环境下打印配置信息
if (config.isDev) {
  console.log('%c[系统配置]', 'color: #409EFF; font-weight: bold;', {
    环境: config.env,
    'API地址': config.baseURL,
    '超时时间': `${config.timeout}ms`
  })
}

export default config

